@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-raised" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{ "mailmessages.periodicDetail.saveButton" | transloco }}</span>
        </button>
        @if (id !== "0") {
            <button class="btn btn-raised red" (click)="deleteClick()">
                <i class="fas fa-trash"></i>
                <span>{{ "mailmessages.periodicDetail.deleteButton" | transloco }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card" [formGroup]="incidentForm">
        <div class="detail-page-card-title">
            {{ "mailmessages.periodicDetail.editPeriodicTitle" | transloco }}
        </div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'mailmessages.periodicDetail.nameLabel' | transloco"
                    formControlName="name"
                    name="notification-name"
                    dataUiid="periodic-detail-incidents-name"
                    [required]="true"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    [label]="'mailmessages.periodicDetail.activeLabel' | transloco"
                    data-uiid="periodic-detail-incidents-active"
                    formControlName="active"
                ></cerrix-checkbox>
            </div>
            <div class="form-group">
                <label>{{ "mailmessages.periodicDetail.periodLabel" | transloco }}</label>
                <ng-select
                    id="periodSelect"
                    name="periodSelect"
                    [items]="periods"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="false"
                    formControlName="period"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                    (change)="setDayNumbers($event)"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.dayLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.dayTooltip' | transloco"
                        matTooltipClass="breakable-tooltip"
                    ></i>
                </label>
                <ng-select
                    id="dayNumberSelect"
                    name="dayNumberSelect"
                    [items]="dayNumbers"
                    [readonly]="!notification.period"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="dayNumber"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.incidentStatusLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.incidentStatusTooltip' | transloco"
                    ></i>
                </label>
                <ng-select
                    id="incidentStatuses"
                    name="incidentStatusSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="incidentStatuses"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="incidentStatuses"
                    [placeholder]="'mailmessages.periodicDetail.allPlaceholder' | transloco"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.userRolesLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.userRolesTooltip' | transloco"
                    ></i>
                </label>
                <ng-select
                    id="userRoleIDs"
                    name="userRolesSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="userRoles"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="userRoleIDs"
                    [placeholder]="'mailmessages.periodicDetail.allPlaceholder' | transloco"
                ></ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "mailmessages.periodicDetail.organizationLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.organizationTooltip' | transloco"
                    ></i>
                </label>
                <cerrix-select-tree
                    class="fullWidth"
                    [getDataMethod]="organizationRequest"
                    formControlName="organizations"
                    [multiselect]="true"
                ></cerrix-select-tree>
            </div>

            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'mailmessages.periodicDetail.messageLabel' | transloco"
                    formControlName="subject"
                    name="notification-subject"
                    dataUiid="periodic-detail-incidents-subject"
                    [required]="true"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                    (click)="setFocusToSubject()"
                ></cerrix-textfield>
                @for (keyword of keywords; track keyword) {
                    <button class="keyword-button" (click)="addKeyword(keyword)">
                        {{ keyword }}
                    </button>
                }
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="notification.message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChangeMessage($event)"
                    (click)="deFocusSubject()"
                    #incidenteditor
                ></cerrix-editor>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
